export function indexGatesUseCase(gateRepostitory) {
    return gateRepostitory.index();
}